import { formatISO } from 'date-fns';

function downloadAsCsv(dataArr, fileName) {
  var dataContent = '';
  dataArr.forEach(function (infoArray, index) {
    let dataString = infoArray.join(',');
    dataContent += index < dataArr.length ? dataString + '\n' : dataString;
  });

  var a = document.createElement('a');
  const mimeType = 'text/csv;encoding:utf-8;';

  if (navigator.msSaveBlob) {
    navigator.msSaveBlob(
      new Blob([dataContent], {
        type: mimeType,
      }),
      fileName
    );
  } else if (URL && 'download' in a) {
    a.href = URL.createObjectURL(
      new Blob([dataContent], {
        type: mimeType,
      })
    );
    a.setAttribute('download', fileName);
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  } else {
    // eslint-disable-next-line
    location.href =
      'data:application/octet-stream,' + encodeURIComponent(dataContent);
  }
}

export default function downloadData(
  mode,
  loc,
  attrInfo,
  data,
  dateRange
) {
  console.log(
    mode,
    loc,
    attrInfo,
    data,
    dateRange
  );

  if (mode === 'climate') {
    let csvData = [
      ['Download Date', formatISO(new Date(), { representation: 'date' })],
      ['Location', loc.name],
      ['Data', attrInfo.name],
      ['Units', attrInfo.units.trim()],
      [],
      [],
      [
        '',
        '',
        'Intermediate Emissions Future (SSP2-4.5)',
        '',
        '',
        'High Emissions Future (SSP3-7.0)',
        '',
        '',
        'Very High Emissions Future (SSP5-8.5)',
      ],
      [
        'Year',
        'Historical',
        'Range Minimum',
        'Mean',
        'Range Maximum',
        'Range Minimum',
        'Mean',
        'Range Maximum',
        'Range Minimum',
        'Mean',
        'Range Maximum',
      ],
    ];

    csvData = [
      ...csvData,
      ...data.historical,
      ...data.projected
    ]

    downloadAsCsv(csvData, `${loc.name}-climate-data.csv`);
  } else if (mode === 'hurricane') {
    let csvData = [
      ['Download Date', formatISO(new Date(), { representation: 'date' })],
      ['Location', loc.name],
      ['Data', 'Hurricane API'],
      [],
      [],
      [
        'Year',
        'Hurricanes',
        'Tropical Storms'
      ],
    ];
    console.log(data);
    for (let year = dateRange.start; year < dateRange.end + 1; year++) {
      const i = year - dateRange.start;
      csvData.push([year, data.hurricanes[i].length, data.tropicalStorms[i].length]);
    }

    downloadAsCsv(csvData, `${loc.name}-Hurricane-API.csv`);
  } else if (mode === 'hazard') {
    data = Object.keys(data).reduce((acc, metric, i) => {
      let impactData = data[metric] || [];

      let index;
      switch (metric) {
        case 'count':
          index = 1;
          break;
        case 'damageCrops':
          index = 2;
          break;
        case 'damageProperty':
          index = 3;
          break;
        case 'deaths':
          index = 4;
          break;
        case 'injuries':
          index = 5;
          break;
        default:
          index = undefined;
          break;
      }

      if (index) {
        for (let year = dateRange.min; year < dateRange.max + 1; year++) {
          if (i === 0) {
            acc.push([year, null, null, null, null, null]);
          }

          let found = impactData.find((arr) => arr[0] === year);

          if (found) {
            acc[year - dateRange.min][index] = found[1];
          } else {
            acc[year - dateRange.min][index] = 0;
          }
        }
      }

      return acc;
    }, []);

    let header = [
      ['Download Date', formatISO(new Date(), { representation: 'date' })],
      ['Location', loc.name],
      ['Data', attrInfo.name],
      [],
      [],
      [
        'Year',
        'Total Reported Episodes',
        'Reported Crop Damage (USD)',
        'Reported Property Damage (USD)',
        'Total Reported Deaths',
        'Total Reported Injuries',
      ],
    ];

    data = data.sort((a, b) => a[0] - b[0]);

    downloadAsCsv([...header, ...data], `${loc.name}-${attrInfo.name}.csv`);
  }
}
